export const formatAmountIndian = (amount) => {
  if (amount == null || isNaN(amount)) return "";

  const absAmount = Math.abs(amount);
  const sign = amount < 0 ? "-" : "";

  if (!absAmount) return '0.00';

  if (absAmount >= 10000000) {
    return `${sign}${(absAmount / 10000000).toFixed(2).replace(/\.00$/, "")} Cr`;
  }

  if (absAmount >= 100000) {
    return `${sign}${(absAmount / 100000).toFixed(2).replace(/\.00$/, "")} Lac`;
  }

  if (absAmount >= 1000) {
    return `${sign}${(absAmount / 1000).toFixed(2).replace(/\.00$/, "")} K`;
  }

  return `${sign}${absAmount}`;
};